<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>
            Mark commissioner as
            @if (commissioner.status) {
                active
            } @else {
                inactive
            }
        </cll-dialog-title>
        <cll-dialog-subtitle>{{ commissioner.name }}</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            @if (commissioner.status) {
                <cll-panel-tonal colour="info">
                    <cll-icon cllPanelIcon>info</cll-icon>
                    <div class="panel-text-group">
                            <span class="panel-text-header">Mark as active</span>
                    </div>
                </cll-panel-tonal>
             }
            @if (!commissioner.status) {
                <cll-panel-tonal colour="warning">
                    <cll-icon cllPanelIcon>info</cll-icon>
                    <span class="warning-bold">Warning</span>
                    <p>Marking this commissioner as <span class="warning-bold">inactive</span> will cause all packages associated with them to be closed.</p>
                </cll-panel-tonal>
            }
            <span>Are you sure you want to proceed?</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (updateCommissionerRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="this.updateCommissionerRequest.loading()"
                (click)="update()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
